export enum WalletTagType {
  Connected = 'connected',
  Multichain = 'multichain',
  Installed = 'installed',
  QrCode = 'qr-code',
  GetStarted = 'get-started',
}
